import apiClient from '@/services/api'

export default {
  async getLegalEntities({ rootState }, { page, size, filter }) {
    try {
      const { data } = await apiClient.post(
        '/api/project/legal_entity/get_all?fields={*,-initial,-is_active}',
        {
          project_id: rootState.applicationState.currentProject.id,
          page,
          size,
          filter
        },
        { cancelPreviousRequests: true }
      )

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data
    } catch (error) {
      throw error.message
    }
  },

  async getLegalEntity({ commit, rootState }, { legal_entity_id }) {
    try {
      const { data } = await apiClient.post('/api/project/legal_entity/get', {
        project_id: rootState.applicationState.currentProject.id,
        legal_entity_id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.legal_entity
    } catch (error) {
      throw error.message
    }
  },

  async deleteLegalEntity({ commit, rootState, dispatch }, { legal_entity_id }) {
    const expectedSessionId = rootState.applicationState.sessionId

    try {
      const { data } = await apiClient.post('/api/project/legal_entity/delete', {
        project_id: rootState.applicationState.currentProject.id,
        legal_entity_id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('setLegalEntity', undefined)

      const oldLegalEntities = [...rootState.applicationState.projectLegalEntities]

      const updatedLegalEntities = oldLegalEntities.filter(item => item.id !== legal_entity_id)

      commit('setProjectLegalEntities', updatedLegalEntities, { root: true })

      dispatch('updateLocalStorage', { expectedSessionId }, { root: true })
    } catch (error) {
      throw error.message
    }
  },

  async createLegalEntity({ commit, rootState, dispatch }, { legal_entity }) {
    const expectedSessionId = rootState.applicationState.sessionId

    try {
      const { data } = await apiClient.post('/api/project/legal_entity/create', {
        project_id: rootState.applicationState.currentProject.id,
        legal_entity
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('setLegalEntity', data.legal_entity)

      const updatedLegalEntities = [data.legal_entity, ...rootState.applicationState.projectLegalEntities]

      commit('setProjectLegalEntities', updatedLegalEntities, { root: true })

      dispatch('updateLocalStorage', { expectedSessionId }, { root: true })

      return data.legal_entity
    } catch (error) {
      throw error.message
    }
  },

  async updateLegalEntity({ commit, rootState, dispatch }, { legal_entity }) {
    const expectedSessionId = rootState.applicationState.sessionId

    try {
      const { data } = await apiClient.post('/api/project/legal_entity/update', {
        project_id: rootState.applicationState.currentProject.id,
        legal_entity
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('setLegalEntity', data.legal_entity)

      const oldLegalEntities = [...rootState.applicationState.projectLegalEntities]

      const updatedLegalEntities = oldLegalEntities.map(item => (item.id === legal_entity.id ? legal_entity : item))

      commit('setProjectLegalEntities', updatedLegalEntities, { root: true })

      dispatch('updateLocalStorage', { expectedSessionId }, { root: true })

      return data.legal_entity
    } catch (error) {
      throw error.message
    }
  },

  async postLinkProject(_, { legal_entity_id, type }) {
    try {
      const { data } = await apiClient.post(`/api/project/legal_entity/${legal_entity_id}/${type}`)

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }
    } catch (error) {
      throw error.message
    }
  },

  async getLegalEntityByTaxId(_, { tax_id }) {
    try {
      const { data } = await apiClient.get(`/api/project/legal_entity/tax_id/${tax_id}?fields={id,staffing_status}`)

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.legal_entities
    } catch (error) {
      throw error.message
    }
  }
}
